import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import CommentBox from './CommentBox';
import "./Comment.modules.css";
import { GAME, SUPER_CHAT } from "../constants/gameConstant"
import PinnedComment from './PinnedComment';

const Comment = forwardRef(({ userInput }, ref) => {

  const [comments, setComments] = useState([]); // コメントを配列で管理
  const [pinnedComment, setPinnedComment] = useState(null); // 固定表示するコメント
  const [isTyping, setIsTyping] = useState(true);// ユーザが入力可能状態か判定
  const [userInputColor, setUserInputColor] = useState("white");// ユーザ入力欄の色を管理
  const [superChatPrice, setSuperChatPrice] = useState(0); // スパチャの額を管理
  const [edittingText, setEdittingText] = useState("　"); // ユーザの入力内容を管理
  const commentBoxRef = useRef(null);

  // コメントが追加されるたびにスクロール位置を調整
  useEffect(() => {
    if (commentBoxRef.current) {
      // スムーズにスクロールさせる
      commentBoxRef.current.scrollTo({
        top: commentBoxRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [comments]);

  // 外部から呼び出せる関数を定義
  useImperativeHandle(ref, () => ({
    // コメントの追加処理
    addComment: (name, input, money, icon) => {
      const newComment = CommentBox(name, input, money, icon);
      setComments((prev) => [...prev, newComment]);

      // 一定金額以上のスパチャを固定表示
      if (money >= GAME.PIN_FIXED_LOWER_PRICE) {
        setPinnedComment(newComment);
      }
    },
    // ユーザー入力欄の色を設定する
    setCommentInputColor: (time, price) => {
      if (time >= SUPER_CHAT.TIME_LEVEL_7) {
        setUserInputColor("red");
      }
      else if (time >= SUPER_CHAT.TIME_LEVEL_5) {
        setUserInputColor("orange");
      }
      else if (time >= SUPER_CHAT.TIME_LEVEL_3) {
        setUserInputColor("yellow");
      }
      else if (time >= SUPER_CHAT.TIME_LEVEL_2) {
        setUserInputColor("cyan");
      }
      else {
        setUserInputColor("white");
      }
      // スパチャ額を設定する
      setSuperChatPrice(price);
    },
    // ユーザーの入力可能状態を設定する
    setUserTypingState: (isUserTypingState) => {
      setIsTyping(isUserTypingState);
    }
  }));

  // ユーザーの入力内容を管理
  useEffect(() => {
    if (userInput) {
      // 空白だと入力欄が消えてしまうので、空白を追加して入力欄を表示
      setEdittingText(userInput + "　");
    } else {
      setEdittingText("　");
    }
  }, [userInput]);

  return (
    <>
      <div className="comment">
        <div className="commentArea">コメントゾーン</div>

        {/* 固定コメントの表示 */}
        {pinnedComment && (
          <PinnedComment comment={pinnedComment} duration={GAME.PIN_FIXED_TIME * 1000} />
        )}

        {/* コメント一覧 */}
        <div ref={commentBoxRef} style={{ border: '1px solid #ccc', height: '100%', width: '100%', overflowY: 'hidden' }}>
          {comments.map((comment, index) => (
            <div key={index} className='comment-item' >
              {comment}
            </div>
          ))}
        </div>
        {isTyping ? (
          <div className="input" style={{ backgroundColor: userInputColor }}>
            {edittingText} 
            <div className="input_comment_price">{"¥" + superChatPrice}</div>
          </div>
        ) : (
          <div className="input" style={{ backgroundColor: "white" }}></div>
        )}
      </div>
    </>
  );
});

export default Comment;
